// 格式化 APY 显示
export function formatApy(apy) {
  if (apy === null || apy === undefined) return "N/A";
  const apyNum = typeof apy === 'number' ? apy : parseFloat(apy);
  if (isNaN(apyNum)) return "N/A";
  return `${apyNum.toFixed(2)}%`;
}

// 格式化 TVL 显示
export function formatTvl(tvl) {
  if (!tvl || tvl === 0) return "N/A";
  if (tvl >= 1e9) return `$${(tvl / 1e9).toFixed(2)}B`;
  if (tvl >= 1e6) return `$${(tvl / 1e6).toFixed(2)}M`;
  if (tvl >= 1e3) return `$${(tvl / 1e3).toFixed(2)}K`;
  return `$${tvl.toFixed(2)}`;
}

// 格式化分数显示
export function formatScore(score) {
  if (score === null || score === undefined) return "N/A";
  const scoreNum = typeof score === 'number' ? score : parseFloat(score);
  if (isNaN(scoreNum)) return "N/A";
  return scoreNum.toFixed(1);
}

// 生成 pools URL
export function getPoolsUrl(slug) {
  if (!slug) return '#';
  return `/pools/${encodeURIComponent(slug)}`;
}

